(function() {
  'use strict';

  function Search($translate, Roles, Utils, VERSION_STATES) {
    function getRoles() {
      return Roles.findAll({ includeSystemRoles: true })
        .then(function(data) {
          return _.sortBy(data.map(function(obj) {
            return { id: obj.doc._id, key: obj.doc._id, title: obj.doc.title };
          }), 'name');
        });
    }

    var roles = getRoles();

    var getSearch = function() {
      var search = {
        facetly: {
          facets: [
            {
              id: 'text',
              type: 'search',
              label: $translate.instant('Start typing to search')
            },
            {
              id: 'groupState',
              type: 'select',
              label: $translate.instant('State'),
              multiselect: true,
              options: [
                { id: VERSION_STATES.draft, title: $translate.instant('Draft') },
                { id: VERSION_STATES.published, title: $translate.instant('Published') },
                { id: VERSION_STATES.archived, title: $translate.instant('Archived') }
              ],
              facetly: false,
              advanced: true
            },
            {
              id: 'ownerRole',
              type: 'select',
              label: $translate.instant('Can be owned by'),
              multiselect: true,
              options: roles,
              facetly: false,
              advanced: true
            },
            {
              id: 'initiatorRole',
              type: 'select',
              label: $translate.instant('Can be initiated by'),
              multiselect: true,
              options: roles,
              facetly: false,
              advanced: true
            },
            {
              id: 'fulltext_extended',
              type: 'text',
              label: $translate.instant('Search by fields'),
              facetly: false,
              advanced: true
            }
          ],
          options: {
            defaultFacet: 'text',
            placeholder: $translate.instant('Start typing to search...'),
            listMaxItems: 10
          }
        },
        filters: [
          {
            id: 'text',
            matchFunc: function(item, _key, value) {
              if (!value) { return true; }

              var val = value.toLowerCase(),
                  name = Utils.safeLowerStr(item.doc.name) +
                          Utils.safeLowerStr(item.doc.description);
              return name.indexOf(val) > -1;
            }
          },
          {
            id: 'state'
          },
          {
            id: 'ownerRole'
          }
        ],
        orders: {
          name: function(item) {
            return item.doc && Utils.safeLowerStr(item.doc.name);
          },
          state: function(item) {
            return item.doc && item.doc.state;
          }
        },
        orderGroups: {
          state: {
            title: $translate.instant('state'),
            orders: ['state', 'name']
          },
          name: {
            title: $translate.instant('name'),
            orders: ['name']
          },
          added: {
            title: $translate.instant('added'),
            orders: ['added', 'name']
          },
          modified: {
            title: $translate.instant('most recent'),
            orders: ['modified', 'name']
          }
        },
        defaultFilter: {
        },
        defaultOrder: 'state'
      };
      return search;
    };

    var service = {
      search: getSearch()
    };

    return service;
  }

  Search.$inject = ['$translate', 'RolesService', 'UtilsService', 'VERSION_STATES'];

  angular.module('component.eventTypes')
    .service('EventTypeSearch', Search);
})();
